import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { assetStorageApi } from 'src/Services/API';
import { CreateDirectoryDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';
import { ApiError } from 'src/types/api-error.types';

export const useCreateDirectory = (
  options?: UseMutationOptions<void, ApiError, CreateDirectoryDto>
) => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation<void, ApiError, CreateDirectoryDto>(
    ['create-directory', assetId],
    async ({ path, name }: CreateDirectoryDto) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }

      await assetStorageApi.assetStorageControllerCreateDirectory(assetId, {
        path,
        name,
      });
    },
    {
      ...options,
      onSettled: (data, error, variables, context) => {
        options?.onSettled?.(data, error, variables, context);
        queryClient.invalidateQueries({ queryKey: ['fetch-documents', assetId] });
        queryClient.invalidateQueries({ queryKey: ['fetch-document-tree', assetId] });
      },
      onSuccess: (data, variables, context) => {
        trackEvent('Document', 'create', 'directory');
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
